import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpandSimple2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"expand-simple-2"} maskId="square-filled-radius-0-stroke-1-IconExpandSimple2"><path fillRule="evenodd" clipRule="evenodd" d="M5 12V5H12V6H6V12H5ZM12 18H18V12H19V19H12V18Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconExpandSimple2;
